const strings = {
  lastAudits: 'Últimas Auditorias',
  approvedAut: 'Aprovado Automático',
  approvedManual: 'Aprovado Manual',
  approvedInconsistency: 'Aprovado com Inconsistência',
  reproved: 'Reprovado',
}

export default strings
